import {Alert, Button} from "@mui/material";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useConfirm} from "../../../../misc/Confirm";
import {useSnackbar} from "../../../../misc/Snackbar";
import {useReloader} from "../hardware/ReloadContext";
import {Keying2Config} from "../../../../api/Keying2";

export function BaseBuildingBanner(props: {
    value: Keying2Config;
}) {
    const confirm = useConfirm();
    const snack = useSnackbar();
    const reload = useReloader();

    const unlink = useAsyncAction(async (input: { project: number }) => {
        try {
            await confirm.confirm("Unlink the base building project? Openings from that project stay in the shortcodes, but show a warning.");
        } catch (e) {
            return;
        }

        try {
            snack.loading("Loading...")
            await api.keying2.setBaseBuilding({project: input.project, baseBuildingProject: null});
            reload.current();
            snack.success("Unlinked");
        } catch (e: any) {
            snack.error(e.toString());
        }
    }, [confirm]);

    if (!props.value.baseBuildingProject) return null;

    return (
        <Alert severity="info" action={
            <Button color="inherit" size="small" disabled={unlink.loading} onClick={() => unlink.callback({project: props.value.project})}>
                Unlink
            </Button>
        }>
            Linked to base building {props.value.baseBuildingProjectName}
        </Alert>
    )
}
